import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

function mapMemberDecisionFromApi(d) {
  return {
    id: d.id,
    title: d.title ?? '',
    description: d.description ?? '',
    branch: d.branch ?? '',
    creator: d.creator ?? '',
    date: d.date ?? '',
    deadline: d.deadline ?? '',
    status: d.status ?? 'pending',
    priority: d.priority ?? 'medium',
    attachments: Array.isArray(d.attachments) ? d.attachments : [],
    votes: Array.isArray(d.votes) ? d.votes : [],
    totalMembers: d.totalMembers ?? 0,
    myVote: d.myVote ?? null,
    myNote: d.myNote ?? '',
  };
}

export async function fetchMemberDecisions() {
  const res = await fetch(`${API_BASE}/api/member/decisions`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل القرارات'));
  const list = Array.isArray(data) ? data : [];
  return list.map(mapMemberDecisionFromApi);
}

export async function fetchMemberDecisionById(id) {
  const res = await fetch(`${API_BASE}/api/member/decisions/${id}`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل القرار'));
  return mapMemberDecisionFromApi(data);
}

export async function submitMemberDecisionVote(id, payload) {
  const res = await fetch(`${API_BASE}/api/member/decisions/${id}/vote`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إرسال التصويت'));
  return mapMemberDecisionFromApi(data);
}
